import type { SortDir } from '../hooks/useTableSort'
import { colClass, type TableCol } from '../lib/tableColumns'

interface SortableThProps {
  label: string
  sortKey: string
  activeKey: string | null
  direction: SortDir
  onSort: (key: string) => void
  /** @deprecated Prefer `col` — kept for compatibility */
  align?: 'left' | 'right'
  col?: TableCol
  className?: string
  rowSpan?: number
  colSpan?: number
}

export function SortableTh({
  label,
  sortKey,
  activeKey,
  direction,
  onSort,
  align,
  col,
  className,
  rowSpan,
  colSpan,
}: SortableThProps) {
  const active = activeKey === sortKey
  const alignRight = align === 'right' || col === 'num' || col === 'currency'
  const classes = ['sortable-th', colClass(col), alignRight ? 'text-right' : '', className]
    .filter(Boolean)
    .join(' ')

  return (
    <th
      className={classes}
      rowSpan={rowSpan}
      colSpan={colSpan}
      onClick={() => onSort(sortKey)}
      aria-sort={active ? (direction === 'asc' ? 'ascending' : 'descending') : 'none'}
    >
      <span className="sortable-th-inner">
        {label}
        <span className="sortable-th-icon" aria-hidden>
          {active ? (direction === 'asc' ? '▲' : '▼') : '⇅'}
        </span>
      </span>
    </th>
  )
}
